import { Membership, User } from 't2-graphql-types';

export const getUserActiveMemberships = (user: User | undefined): Membership[] =>
  user?.memberships?.filter((membership) => membership?.status === 'ACTIVE') || [];
